import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common'
import { HeaderService } from '@app/services/header.service';
import { BrandingDto } from '../../../../../froexishared/src/dto/BrandingDto';
import SessionStorage from '@app/helpers/SessionStorage';
import { RouterOutletService } from '@app/services/router-outlet.service';
import { CheckInStatusComponent } from '@app/pages/check-in-status/check-in-status.component';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { YesNoDialogComponent } from '@app/dialogs/yes-no-dialog/yes-no-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { BillingService } from '@app/services/billing.service';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { SpinnerService } from '@app/services/spinner.service';
import { GenericMessageDialogComponent } from '@app/dialogs/generic-message-dialog/generic-message-dialog.component';
import { GenericMessage } from '@app/interfaces/generic-message';
@Component({
  selector: 'header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  navigationVisible: boolean = false;
  checkinStatusActive: boolean;
  branding: BrandingDto;
  constructor(
    private location: Location,
    private headerService: HeaderService,
    private routerOutletService: RouterOutletService,
    private router: Router,
    private dialog: MatDialog,
    private translate: TranslateService,
    private billingService: BillingService,
    private spinnerService: SpinnerService
  ) {


  }
  ngOnInit() {
    this.branding = SessionStorage.BrandingData;

    this.headerService.navigationVisible.subscribe(result => {
      setTimeout(() => {
        this.navigationVisible = result;
      });
    })

    this.routerOutletService.routerContentChanged.subscribe(event => {
      setTimeout(() => {
        if (event instanceof CheckInStatusComponent) {
          this.checkinStatusActive = true;
        } else {
          this.checkinStatusActive = false;
        }
      });
    })
  }

  navigateBack() {
    if (this.router.url.includes("billview")) {
      this.dialog.open(YesNoDialogComponent, {
        disableClose: true,
        hasBackdrop: true,
        width: "auto",
        data: { messageText: this.translate.instant('common.billview_interrupted'), messageType: 'INFORMATION', showIcon: false }
      }).afterClosed().subscribe(data => {
        if (data) {
          this.spinnerService.setSpinnerVisibility(true);
          this.billingService.BillviewInterrupt(SessionStorage.TransactionId).subscribe({
            next: (result) => {
              let messageData: GenericMessage = { messageText: this.translate.instant('common.transaction_cancelled'), messageType: 'INFORMATION', showIcon: false }
              this.spinnerService.setSpinnerVisibility(false);
              this.dialog.open(GenericMessageDialogComponent, {
                disableClose: true,
                hasBackdrop: true,
                minWidth: "auto",
                data: messageData
              }
              ).afterClosed().subscribe(() => {
                this.location.back();
              })
            },
            error: (err: HttpErrorResponse) => {
              this.spinnerService.setSpinnerVisibility(false);
              let messageData: GenericMessage = { messageText: this.translate.instant('common.transaction_cancel_error'), messageType: 'ERROR', showIcon: false }
              this.dialog.open(GenericMessageDialogComponent, {
                disableClose: true,
                hasBackdrop: true,
                minWidth: "auto",
                data: messageData
              }
              )
            }

          })
        }
      })
    } else {
      console.log(this.router.url)
      if (!this.checkinStatusActive) {
        this.location.back();
      } else {
        this.router.navigateByUrl('/welcome')
      }
    }

  }

  backStyle() {
    let styles = {};
    styles["background-color"] = SessionStorage.BrandingData.PrimaryColor;
    return styles
  }
  navigationStyle() {
    let styles = {};
    styles["color"] = SessionStorage.BrandingData.SecondaryColor;
    return styles
  }
}
